import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";

export class Beauty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  render () {
    return (
      <div class="main">
        <Helmet>
          <title>Онлайн-запись для салона красоты и массажа – Бесплатная CRM | Planna</title>
          <meta name="description" content="Автоматизируйте запись клиентов в салон, барбершоп, массажную студию. Напоминания, единый календарь сотрудников, QR-код. Бесплатно навсегда." />
        </Helmet>
        <h1 class="main2">Онлайн-запись и CRM для салона красоты, массажа, барбершопа – Бесплатно</h1>
        <div class="main3">Замените тетрадку, звонки и WhatsApp на современную систему учёта клиентов. Ваши мастера увидят своё расписание, клиенты записываются 24/7 через QR-код, а вы получаете аналитику и контроль. Бесплатно навсегда.</div>
        <h2 class="main2 orange">Почему вашему салону нужна эта система?</h2>
        <ul class="main3">
          <li>Клиенты теряются, потому что не могут дозвониться в нерабочее время.</li>
          <li>Мастера путаются в расписании – двойные брони, сдвиги.</li>
          <li>Нет напоминаний – клиенты забывают и не приходят (до 20% неявок).</li>
          <li>Вы не видите картину – кто из мастеров загружен, кто свободен, какие услуги популярны, какие дополнительные услуги выбирают.</li>
        </ul>
        <div class="main3">Решение – наша бесплатная CRM, созданная специально для сферы услуг.</div>

        <h2 class="main2">Что вы получаете?</h2>
<div class="main3">
✅ Онлайн-запись 24/7<br/>

Клиенты сами выбирают услугу, мастера и удобное время на вашей странице. Никаких звонков в 11 вечера. Вы просто принимаете готовую заявку.
</div><div class="main3">
✅ Запись по телефону – тоже в системе<br/>

Кто-то позвонил? Администратор вносит бронь вручную одним кликом. Всё в одном календаре.
</div><div class="main3">
✅ Единый календарь сотрудников<br/>

Каждый мастер видит своё расписание в телефоне. Никаких вопросов «когда моя смена?». А если мастер записался к стоматологу через наш сервис – это время автоматически блокируется в рабочем календаре. Никаких двойных бронирований.
</div><div class="main3">
✅ Выбор дополнительных услуг при бронировании<br/>

Клиент добавляет к стрижке тонирование, к массажу - прогревающие камни, к маникюру - снятие. Цена обновляется сразу. Никаких сюрпризов в день визита. Мастер заранее видит что ему предстоит делать, клиент ничего не забудет сказать мастеру, мастер сам напомнит.
</div><div class="main3">
✅ Автоматические напоминания<br/>

Клиент получает уведомление за день – в Telegram, SMS или push. Неявки сокращаются на 70%. Вы не теряете деньги.
</div><div class="main3">
✅ Своя страница с QR-кодом<br/>

Мы создаём для вас персональную страницу бронирования. Распечатайте QR-код и повесьте на стойке – клиенты записываются сами. Ссылку можно добавить в Instagram, WhatsApp, на сайт.
</div><div class="main3">
✅ Аналитика и отчёты<br/>

· Загрузка каждого мастера по часам и дням
· Самые популярные услуги
· Средний чек
· Количество новых и повторных клиентов
</div><div class="main3">
✅ Для массажных студий – поиск партнёра<br/>

Если вы проводите спа-программы для двоих или парный массаж, клиенты могут отметить «ищу партнёра». Система найдёт второго участника. Бронирование подтвердится, когда пара соберётся. Вы получаете двух клиентов вместо одного.
</div><div class="main3">
✅ Для барбершопов – учёт нескольких мастеров<br/>

Добавьте любого количества сотрудников. Каждый видит свои записи. Администратор – общее расписание. Можно настроить комиссию, выходные дни, перерывы.
</div>

        <h2 class="main2 orange">Удобно для любого формата</h2>

        <div class="main3 w40"><table style={{textAlign: "left"}} class="table table-striped">
          <thead><tr><th>Тип бизнеса</th><th>Как помогает CRM</th></tr></thead>
          <tbody>
            <tr>
            <td>Салон красоты (3+ мастера)</td><td>Расписание всех мастеров в одном окне. Напоминания клиентам. Отчёты по выручке.</td>
            </tr><tr>
            <td>Барбершоп</td><td>Учёт разных услуг (стрижка, борода, камуфляж). Привязка к конкретному барберу.</td>
            </tr><tr>
            <td>Массажный кабинет (1-2 мастера)</td><td>Онлайн-запись без администратора. Напоминания. Поиск партнёра для парного массажа.</td>
            </tr><tr>
            <td>Самозанятый мастер (массаж, косметология, ногтевой сервис)</td><td>Бесплатная онлайн-запись без абонентки. QR-код для соцсетей. Всё в смартфоне.</td>
            </tr>
          </tbody></table>

        </div>

        <h2 class="main2">Как это работает за 5 минут</h2>
        <p class="main3">
          <div class="nowrap">{this.state.isAuthenticated ? <><span class="btndone">Зарегистрироваться</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Зарегистрировать бизнес бесплатно</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить услуги</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configservices">Добавить услуги</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить русурсы</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configresources">Добавить русурсы (мастера)</a>}<div class="arrowright"></div></div>
          <div class="nowrap"><a style={{marginLeft: "5px"}} class="btn btn-primary" href="configqrcode">Распечатать QR-код со ссылкой для клиентов</a><div class="arrowright"></div></div>
          <a style={{marginLeft: "5px"}} class="btn btn-primary" href={this.state.companies.length > 0 ? `booking/${this.state.companies[0].id}` : "booking"}>Начать записывать клиентов</a>
        </p>

          <h2 class="main2 orange">Часто задаваемые вопросы</h2>
          <ul class="main3">
            <li><b>Это действительно бесплатно?</b><p><b>Ответ:</b> Да. Никакой абонентской платы, процентов с броней. Вы платите только за SMS (если подключите) и комиссию банка за онлайн-оплату (по желанию).</p></li>
            <li><b>А если клиент звонит? Я могу записать его вручную?</b><p><b>Ответ:</b> Да. Администратор в календарь салона или мастер в собственный календарь может добавить бронь вручную за 10 секунд. Всё остальное (напоминание, учёт) работает автоматически.</p></li>
            <li><b>Нужно ли мастерам устанавливать приложение?</b><p><b>Ответ:</b> Достаточно браузера на телефоне – открывают свою страницу и видят расписание. Можно также установить PWA (как приложение). Но мобильное приложение дает дополнительные возможности.</p></li>
            <li><b>Как подключить?</b><p><b>Ответ:</b> Регистрируетесь, добавляете услуги и мастеров, получаете QR-код – всё. Настройка за 15 минут.</p></li>
            <li><b>А если у меня один мастер (я сам)?</b><p><b>Ответ:</b> Тоже подходит. Вы видите свою загрузку, клиенты записываются онлайн, напоминания летят автоматически. Бесплатно.</p></li>
          </ul>
      </div>
    );
  }
}
